import { DirectiveBinding } from 'vue';

interface DirectiveElement extends Element {
    onMouseOver?: () => void;
    onMouseLeave?: () => void;
}

export default {
    name: 'hover',
    mounted(el: DirectiveElement, binding: DirectiveBinding) {
        el.onMouseOver = () => {
            binding.value(true);
        }
        el.onMouseLeave = () => {
            binding.value(false);
        }
        el.addEventListener('mouseover', el.onMouseOver);
        el.addEventListener('mouseleave', el.onMouseLeave);
    },
    unmounted(el: DirectiveElement) {
        if (el?.onMouseOver) el.removeEventListener('mouseover', el.onMouseOver);
        if (el?.onMouseLeave) el.removeEventListener('mouseleave', el.onMouseLeave);
    },
}